<template>
  <div class="rule-form-step rule-form-step--scaling-up rule-form-step--scaling-up--step-4 flex max-w-4xl flex-col gap-5 py-5">
    <form-block
      :title="tr('Manage original ad')"
      :description="tr('You can set whether the scaled-up original ad should continue running or stop automatically.')"
    >
      <ui-radio-group
        :model-value="entity.settings.stop_original ? 'stop' : 'keep'"
        :disabled="$parent.readonlyMode"
        class="flex flex-col gap-2.5"
        @update:model-value="(value) => entity.settings.stop_original = value === 'stop'"
      >
        <label class="flex w-fit items-center gap-2 text-sm text-foreground cursor-pointer">
          <ui-radio-group-item value="keep" />
          {{ tr('Keep original ad running') }}
        </label>
        <label class="flex w-fit items-center gap-2 text-sm text-foreground cursor-pointer">
          <ui-radio-group-item value="stop" />
          {{ tr('Stop original ad automatically') }}
        </label>
      </ui-radio-group>
    </form-block>

    <ad-creation-method-block :entity="entity" :disabled="$parent.readonlyMode" />

    <cta-block
      v-if="ctaBlockIsVisible"
      :entity="entity"
      :disabled="$parent.readonlyMode"
      switchable
    />

    <template v-if="siteLinksBlockIsVisible">
      <site-links-block :entity="entity" :disabled="$parent.readonlyMode" />
    </template>

    <url-params-block
      :entity="entity"
      :disabled="$parent.readonlyMode"
    />
  </div>
</template>

<script>
import { AD_CREATION_METHOD } from '@/consts.js';
import RuleFormStepMixin from '@/mixins/RuleForm/Step.js';
import AdCreationMethodBlock from '@/ui/components/RuleForm/Blocks/AdCreationMethodBlock.vue';
import CtaBlock from '@/ui/components/RuleForm/Blocks/CtaBlock.vue';
import SiteLinksBlock from '@/ui/components/RuleForm/Blocks/SiteLinksBlock.vue';
import UrlParamsBlock from '@/ui/components/RuleForm/Blocks/UrlParamsBlock.vue';

export default {
  name: 'ScalingUpRuleFormStep4',
  components: {
    AdCreationMethodBlock,
    CtaBlock,
    SiteLinksBlock,
    UrlParamsBlock,
  },
  mixins: [ RuleFormStepMixin ],
  computed: {
    ctaBlockIsVisible() {
      return this.entity.settings.ad_creation_method === AD_CREATION_METHOD.CREATIVE
        && !this.entity.isPageLikeCampaign
        && !this.entity.isInstagramProfileVisitCampaign;
    },
    siteLinksBlockIsVisible() {
      return this.entity.settings.ad_creation_method === AD_CREATION_METHOD.CREATIVE
        && !this.entity.isPageLikeCampaign
        && !this.entity.isInstagramProfileVisitCampaign
        && this.entity.output_campaign?.isSiteLinksEligible;
    },
  },
  methods: {
    validate() {
      if (!this.validateBlocks()) {
        return false;
      }

      return true;
    },
  },
};
</script>
